'use strict';
var moment = require('moment-timezone');
var Dateline = require('dateline');
module.exports = {
    formatPublishTime: function (time) {
        return module.exports.formatTime(time, 'h:mm A z | MMM D, YYYY', 'America/New_York');
    },
    formatPublishTimeMeta: function (time) {
        return module.exports.formatTime(time, '', 'America/New_York');
    },
    formatTime: function (time, formatString, timezone) {
        if (timezone) {
            if (moment.hasOwnProperty('tz')) {
                return moment.tz(time, timezone).format(formatString);
            } else {
                console.error('Must install "moment-timezone" to use this function with the timezone parameter');
            }
        } else {
            return moment(time).format(formatString);
        }
    },
    formatUnixTime: function (unixTime, formatString, timezone) {
        if (timezone) {
            if (moment.hasOwnProperty('tz')) {
                return moment.unix(unixTime).tz(timezone).format(formatString);
            } else {
                console.error('Must install "moment-timezone" to use this function with the timezone parameter');
            }
        } else {
            return moment.unix(unixTime).format(formatString);
        }
    },
    getAPDate: function (dateStr, options) {
        var date = Dateline(new Date(dateStr));
        return date.getAPDate(options);
    },
    getAPTime: function (dateStr, options) {
        var date = Dateline(new Date(dateStr));
        return date.getAPTime(options);
    },
    slugify: function (str) {
        return str.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]+/g, '').replace(/\-\-+/g, '-').trim();
    },
    fixedRound: function (number, precision) {
        if (typeof number === 'undefined') {
            throw new Error();
        }
        var multiplier = Math.pow(10, precision + 1);
        var wholeNumber = Math.floor(number * multiplier);
        return (Math.round(wholeNumber / 10) * 10 / multiplier).toFixed(precision);
    },
    getAPStateAbbrev: function (state) {
        var abbrevs = {
                'Alabama': 'Ala.',
                'Alaska': 'Alaska',
                'Arizona': 'Ariz.',
                'Arkansas': 'Ark.',
                'California': 'Calif.',
                'Colorado': 'Colo.',
                'Connecticut': 'Conn.',
                'Delaware': 'Del.',
                'District of Columbia': 'D.C.',
                'Florida': 'Fla.',
                'Georgia': 'Ga.',
                'Hawaii': 'Hawaii',
                'Idaho': 'Idaho',
                'Illinois': 'Ill.',
                'Indiana': 'Ind.',
                'Iowa': 'Iowa',
                'Kansas': 'Kan.',
                'Kentucky': 'Ky.',
                'Louisiana': 'La.',
                'Maine': 'Maine',
                'Maryland': 'Md.',
                'Massachusetts': 'Mass.',
                'Michigan': 'Mich.',
                'Minnesota': 'Minn.',
                'Mississippi': 'Miss.',
                'Missouri': 'Mo.',
                'Montana': 'Mont.',
                'Nebraska': 'Neb.',
                'Nevada': 'Nev.',
                'New Hampshire': 'N.H.',
                'New Jersey': 'N.J.',
                'New Mexico': 'N.M.',
                'New York': 'N.Y.',
                'North Carolina': 'N.C.',
                'North Dakota': 'N.D.',
                'Ohio': 'Ohio',
                'Oklahoma': 'Okla.',
                'Oregon': 'Ore.',
                'Pennsylvania': 'Pa.',
                'Rhode Island': 'R.I.',
                'South Carolina': 'S.C.',
                'South Dakota': 'S.D.',
                'Tennessee': 'Tenn.',
                'Texas': 'Texas',
                'Utah': 'Utah',
                'Vermont': 'Vt.',
                'Virginia': 'Va.',
                'Washington': 'Wash.',
                'West Virginia': 'W.Va.',
                'Wisconsin': 'Wis.',
                'Wyoming': 'Wyo.'
            };
        return abbrevs[state];
    },
    colors: {
        BACKGROUND_GRAY: '#f0f0f0',
        GRAY: '#5b5e5f',
        LIGHT_GRAY: '#999999',
        PURPLE: '#636',
        GREEN: '#44ab43',
        BLUE: '#008fd5',
        YELLOW: '#f6b900',
        RED: '#ff2700',
        BLACK: '#3c3c3c',
        WHITE: '#fff',
        LIGHT_GREEN: '#bfd7a6',
        GRID_GRAY: '#cdcdcd'
    }
};